import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface DailyCheckInfoCardProps {
  month?: number;
  count?: number;
  point?: number;
  className?: string;
}
export const DailyCheckInfoCard = t0 => {
  const $ = _c(19);
  const {
    month,
    count,
    point,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-24 rounded-medium bg-Gray-white px-35 py-16", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = typeof month === "number" ? `${month}월 출석` : "-";
  let t3;
  if ($[2] !== t2) {
    t3 = <p className="mb-4 typo-body4">{t2}</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = typeof count === "number" ? `${count}회` : "-";
  let t5;
  if ($[4] !== t4) {
    t5 = <p className="font-700 text-B-500 typo-body3">{t4}</p>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <div className="grow">{t3}{t5}</div>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-24 w-1 bg-Gray-200" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="mb-4 typo-body4">보유</p>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== point) {
    t9 = typeof point === "number" ? `${point.toLocaleString()}P` : "-";
    $[11] = point;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <div className="grow">{t8}<p className="font-700 text-B-500 typo-body3">{t9}</p></div>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t1 || $[16] !== t10 || $[17] !== t6) {
    t11 = <section className={t1}>{t6}{t7}{t10}</section>;
    $[15] = t1;
    $[16] = t10;
    $[17] = t6;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};